var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useControlled, } from '@mui/material/utils';
import ListItem from './ListItem';
import CubeItem from './CubeItem';
import clsx from 'clsx';
var UploadList = function (_a) {
    var items = _a.items, type = _a.type, iconType = _a.iconType, onRemove = _a.onRemove, onRefresh = _a.onRefresh, itemRender = _a.itemRender, classes = _a.classes, nameRenderProp = _a.nameRender, onSelect = _a.onSelect, selectedProp = _a.selected, restProps = __rest(_a, ["items", "type", "iconType", "onRemove", "onRefresh", "itemRender", "classes", "nameRender", "onSelect", "selected"]);
    if (!items || (items === null || items === void 0 ? void 0 : items.length) === 0)
        return null;
    var _b = useControlled({
        controlled: selectedProp,
        default: '',
        name: 'TreeView',
        state: 'selected',
    }), selected = _b[0], setSelectedState = _b[1];
    // 取消上传
    var handleClose = function (file) { return onRemove(file); };
    // 重新上传
    var handleRefresh = function (file) { return onRefresh(file); };
    // handleSelection
    var handleSelect = function (file, index, files) {
        setSelectedState(file);
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(file, index, files);
    };
    // 修饰文件名称
    var nameRender = function (file) {
        if (nameRenderProp != null && typeof nameRenderProp === 'function') {
            return nameRenderProp(file);
        }
        return file.name;
    };
    return React.createElement(React.Fragment, null, items.map(function (item, index, items) {
        var _a;
        var itemProps = {
            className: clsx(classes.root, (_a = {},
                _a[classes.selected] = typeof selected === 'object' ? selected.uid === item.uid : selected === item.uid,
                _a)),
            name: item.name,
            size: item.size,
            percent: item.percent_from_outside || item.percent,
            status: item.status_from_outside || item.status,
            url: item.url,
            iconType: iconType,
            originFileObj: item.originFileObj,
            nameRender: function () { return nameRender(item); },
            onClose: function () { return handleClose(item); },
            onRefresh: function () { return handleRefresh(item); },
            onClick: function () { return handleSelect === null || handleSelect === void 0 ? void 0 : handleSelect(item, index, items); }
        };
        var children = null;
        if (itemRender && typeof itemRender === 'function') {
            children = React.createElement("div", { key: item.uid },
                " ",
                itemRender(itemProps),
                " ");
        }
        else if (type === 'cube') {
            children = React.createElement(CubeItem, __assign({ key: item.uid }, itemProps, restProps));
        }
        else {
            children = React.createElement(ListItem, __assign({ key: item.uid }, itemProps, restProps));
        }
        return children;
    }));
};
export default UploadList;
